import { http } from "../src/utils/index"

export const getFarmingList = (p: any) => {
    return http({
        url: '/cooperationH5/index/my/farming',
        method: 'GET',
        params: p
    })
}

// 获取品种
export const getVarietyList = () => {
    return http({
        url: '/cooperationH5/farmer/info/source/typeAll',
        method: 'GET'
    })
}

// 获取资源
export const getResourceData = (p: any) => {
    return http({
        url: '/cooperationH5/index/my/source',
        method: 'GET',
        params: p
    })
}

// 获取农事详情
export const getFarmingDetail = (p: any) => {
    return http({
        url: '/cooperationH5/farming/option/detail',
        method: 'GET',
        params: p
    })
}

// 忽略农事
export const igonreFarming = (p: any) => {
    return http({
        url: '/cooperationH5/farming/option/ignore',
        method: 'GET',
        params: p
    })
}

// 保存农事记录
export const saveFarmingRecord = (data: any) => {
    return http({
        url: '/cooperationH5/farming/record/index',
        method: 'POST',
        data
    })
}
// 编辑农事记录
export const updateFarmingRecord = (data: any) => {
    return http({
        url: '/cooperationH5/farming/record/index',
        method: 'PUT',
        data
    })
}

// 获取合作社
export const getCooperationList = () => {
    return http({
        url: '/cooperationH5/center/findCooperation',
        method: 'GET'
    })
}

// 获取资源详情
export const getSourceDetail = (params: object) => {
    return http({
        url: '/cooperationH5/farmer/source/info',
        method: 'GET',
        params
    })
}

// 编辑农户资源
export const saveSourceDetail = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/source/index',
        method: 'POST',
        data
    })
}
// 保存农户资源
export const editSourceDetail = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/source/index',
        method: 'PUT',
        data
    })
}

// 获取跟进记录
export const getTrailData = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/record/pageList',
        method: 'POST',
        data
    })
}

// 新增资源跟进记录
export const addTrailData = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/record/save',
        method: 'POST',
        data
    })
}

// 修改资源跟进记录
export const updateTrailData = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/record/save',
        method: 'PUT',
        data
    })
}

// 删除资源跟进记录
export const delTrailData = (params: object) => {
    return http({
        url: '/cooperationH5/farmer/record/del',
        method: 'DELETE',
        params
    })
}

// 获取农户地块信息
export const getFarmerLandList = (params: object) => {
    return http({
        url: '/cooperationH5/farmer/area/pageList',
        method: 'GET',
        params
    })
}

// 获取模型列表
export const getPlantModelData = (params: any) => {
    return http({
        url: 'cooperationH5/farmer/plant/pageList',
        method: 'GET',
        params
    })
}

// 新增农户地块
export const addFarmerLand = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/area/index',
        method: 'POST',
        data
    })
}
// 编辑农户地块
export const updateFarmerLand = (data: object) => {
    return http({
        url: '/cooperationH5/farmer/area/index',
        method: 'PUT',
        data
    })
}
// 删除农户地块
export const deleteFarmerLand = (id: string) => {
    return http({
        url: '/cooperationH5/farmer/area/index?id=' + id,
        method: 'DELETE'
    })
}

// 获取农户地块信息
export const getFarmerLandData = (id: string) => {
    return http({
        url: '/cooperationH5/farmer/area/index?id=' + id,
        method: 'GET'
    })
}

// 获取农事列表
export const getFarmerFarmingList = (params: any) => {
    return http({
        url: '/cooperationH5/farmer/farming/record/record/pageList',
        method: 'GET',
        params
    })
}

// 删除农事记录
export const delFarmingData = (params: object) => {
    return http({
        url: '/cooperationH5/farming/record/index',
        method: 'DELETE',
        params
    })
}
// 查看农事记录
export const getFarmingData = (params: object) => {
    return http({
        url: '/cooperationH5/farming/record/index',
        method: 'GET',
        params
    })
}

// 获取农事类型
export const getFarmingTypeData = () => {
    return http({
        url: '/cooperationH5/farmer/farming/record/farming/type/pageList',
        method: 'GET',
        params: { page: 1, pageSize: 999 }
    })
}

// 获取农事任务数据
export const getFarmingTaskData = (params: object) => {
    return http({
        url: '/cooperationH5/farmer/farming/pageList',
        method: 'GET',
        params
    })
}

// 获取地块筛选
export const getLandFilterData = (params: object) => {
    return http({
        url: '/cooperationH5/farmer/area/arealist',
        method: 'GET',
        params
    })
}
// 保存农名信息
export const saveFarmerInfo = (data: object) => {
    return http({
        url: '/cooperationH5/index/my/update',
        method: 'POST',
        data,
    })
}

// 获取农事任务相关提示
export const getFarmingTaskCountApi = (sourceId:string) => {
    return http({
        url: `/cooperationH5/index/my/countNotOption?sourceId=${sourceId}`,
        method: 'GET'
    })
}

// 删除农事记录
export const delFarmingRecordApi = (id: string | number) => {
    return http({
        url: `cooperationH5/farmer/farming/record/record/index?id=${id}`,
        method: 'DELETE'
    })
}

// 获取全部品种
export const getSourceTypeApi = () => {
    return http({
        url: `/cooperationH5/farmer/info/source/typeAll`,
        method: 'GET'
    })
}

// 收购记录统计
export const getPurchaseCountApi = (data: object) => {
    return http({
        url: `/cooperationH5/purchase/pageCountList`,
        method: 'POST',
        data
    })
}

export const getPurchaseListApi = (data: object) => {
    return http({
        url: `/cooperationH5/purchase/pageList`,
        method: 'POST',
        data
    })
}